(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hb-catering-landing"] && !Shopify.designMode) return;
  try {
    
(function () {
  function fmt(n) {
    return '₹' + Number(n).toLocaleString('en-IN');
  }

  function init(root) {
    if (!root || root.dataset.hbcReady) return;
    root.dataset.hbcReady = '1';

    var min = parseInt(root.dataset.min, 10) || 1;
    var form = root.querySelector('.hbc-form');
    var pkg = root.querySelector('[data-hbc-package]');
    var kids = root.querySelector('[data-hbc-kids]');
    var date = root.querySelector('[data-hbc-date]');
    var out = function (k) { return root.querySelector('[data-hbc-out="' + k + '"]'); };

    if (date) {
      var t = new Date();
      t.setMinutes(t.getMinutes() - t.getTimezoneOffset());
      date.min = t.toISOString().slice(0, 10);
    }

    function update() {
      var opt = pkg && pkg.selectedOptions[0];
      var price = opt && opt.value ? parseFloat(opt.dataset.price) || 0 : 0;
      var n = kids ? parseInt(kids.value, 10) || 0 : 0;
      var hint = out('hint');

      out('pkg').textContent = opt && opt.value ? opt.value : '—';
      out('price').textContent = price ? fmt(price) : '—';
      out('kids').textContent = n || '—';

      var ok = price && n >= min;
      out('total').textContent = ok ? fmt(price * n) : '—';
      out('price-field').value = price ? fmt(price) : '';
      out('total-field').value = ok ? fmt(price * n) + ' (estimate, excl. add-ons, delivery & taxes)' : '';

      if (n && n < min) {
        hint.textContent = 'Minimum order is ' + min + ' children.';
        hint.hidden = false;
      } else {
        hint.hidden = true;
      }
    }

    function goToForm(focusEl) {
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (focusEl) setTimeout(function () { focusEl.focus({ preventScroll: true }); }, 500);
    }

    root.querySelectorAll('[data-hbc-choose]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        pkg.value = btn.dataset.hbcChoose;
        update();
        goToForm(kids && !kids.value ? kids : null);
      });
    });

    root.querySelectorAll('[data-hbc-addon]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var name = btn.dataset.hbcAddon;
        var box = Array.prototype.find.call(root.querySelectorAll('[data-hbc-station]'), function (c) {
          return c.dataset.hbcStation === name;
        });
        if (box) box.checked = true;
        goToForm(null);
      });
    });

    if (pkg) pkg.addEventListener('change', update);
    if (kids) kids.addEventListener('input', update);
    if (form) form.addEventListener('submit', update);
    update();

    // Gallery page dots (mobile 2x2 slider: 4 photos per page)
    var track = root.querySelector('.hbc-gallery');
    var dots = root.querySelector('[data-hbc-dots]');
    if (track && dots) {
      var pages = Math.ceil(track.children.length / 4);
      if (pages > 1) {
        for (var p = 0; p < pages; p++) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'hbc-gallery__dot';
          d.setAttribute('aria-label', 'Show photos page ' + (p + 1));
          d.dataset.page = p;
          dots.appendChild(d);
        }
        var pageWidth = function () { return track.clientWidth + parseFloat(getComputedStyle(track).columnGap || 0); };
        var mark = function () {
          var cur = Math.round(track.scrollLeft / pageWidth());
          Array.prototype.forEach.call(dots.children, function (el, i) { el.setAttribute('aria-current', i === cur ? 'true' : 'false'); });
        };
        dots.addEventListener('click', function (e) {
          if (e.target.dataset.page) track.scrollTo({ left: e.target.dataset.page * pageWidth(), behavior: 'smooth' });
        });
        track.addEventListener('scroll', mark, { passive: true });
        mark();
      }
    }

    // Gallery lightbox
    var lb = root.querySelector('[data-hbc-lightbox]');
    var photos = Array.prototype.slice.call(root.querySelectorAll('[data-hbc-photo]'));
    if (lb && photos.length && lb.showModal) {
      var img = lb.querySelector('[data-hbc-lb-img]');
      var idx = 0;
      var show = function (i) {
        idx = (i + photos.length) % photos.length;
        img.src = photos[idx].dataset.hbcPhoto;
        img.alt = photos[idx].dataset.hbcAlt || '';
      };
      photos.forEach(function (btn, i) {
        btn.addEventListener('click', function () { show(i); lb.showModal(); });
      });
      lb.addEventListener('click', function (e) {
        var act = e.target.dataset.hbcLb;
        if (act === 'prev') show(idx - 1);
        else if (act === 'next') show(idx + 1);
        else if (act === 'close' || e.target === lb) lb.close();
      });
      lb.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') show(idx - 1);
        if (e.key === 'ArrowRight') show(idx + 1);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-hbc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-collaboration"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.hbxReady) return;
    root.dataset.hbxReady = '1';
    root.classList.add('hbx--js');

    // Mobile "See what's included" toggles (lists are always open on desktop via CSS)
    root.querySelectorAll('[data-hbx-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') !== 'true';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.closest('.hbx-opp__body').classList.toggle('is-open', open);
        var label = btn.querySelector('[data-hbx-toggle-label]');
        if (label) label.textContent = open ? label.dataset.open : label.dataset.closed;
      });
    });

    // Card buttons pre-select their collaboration type in the form
    var select = root.querySelector('[data-hbx-type-select]');
    root.querySelectorAll('[data-hbx-type]').forEach(function (link) {
      link.addEventListener('click', function () {
        var type = link.dataset.hbxType;
        if (!select || !type) return;
        var match = Array.prototype.find.call(select.options, function (o) { return o.value === type; });
        if (match) select.value = match.value;
      });
    });
  }

  function initAll() { document.querySelectorAll('[data-hbx]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
